import { createSlice } from "@reduxjs/toolkit";
const OpdDoctorSlice = createSlice({
    name:"opdDoctor",
    initialState:{
        opdDoctorList:[],
        opdBranchList:[],
        isCached:false,
        lastFetched:null
    },
    reducers:{
        setOPdDoctorList(state,action){
            state.opdDoctorList = action.payload;
            state.isCached = true;
            state.lastFetched = Date.now();
        },
        setOpdBranchList(state,action){
            state.opdBranchList = action.payload;
        },
        clearOpdDoctorCache(state){
            state.opdDoctorList = [];
            state.opdBranchList = [];
            state.isCached = false;
            state.lastFetched = null;
        }

    },
})
export const {setOPdDoctorList,setOpdBranchList,clearOpdDoctorCache}  = OpdDoctorSlice.actions;
export default OpdDoctorSlice.reducer;